import { modules } from "veritone-redux-common";
import { all, select, put, takeEvery, delay } from "redux-saga/effects";
import { get, includes, sortBy, reverse, omit, isEmpty, isNumber } from "lodash";
import {
  getVisualRefreshData,
  RE_PROCESS_SAGA,
  REMOVE_VISUAL_REFRESH_DATA_SAGA,
  GET_VISUAL_DATA_REFRESH_SAGA,
  getVisualRefreshDataSaga as getVisualRefreshDataSagaAction
} from "./visualDataRefresh";
import {
  STATUS_ENGINE_ERROR,
  JOB_STATUS,
  STATUS_ENGINE_PREPARING
} from "../../../helpers/constant";
import {
  getVisualDataRefreshApi,
  rerunVisualDataRefreshApi,
  removeVisualDataRefreshApi
} from "../../../helpers/visualDataRefreshApi";
import { getText } from "../../../helpers/formatData";
import { showToast } from "./notification";
import constants from "../../../helpers/constant";
import {
  removeChartData,
  loadChartDataCampaignSaga,
  loadCampaigns,
  updateCampaign
} from "./campaign";
import { loadAdvertiserDetailSaga } from './advertiser';

const {
  config: { getConfig }
} = modules;

export function* reProcessSaga(action) {
  const { queue } = action.payload;
  const config = yield select(getConfig);
  const results = yield rerunVisualDataRefreshApi(config.urlApi, queue.campaign_id);
  if (results.error) {
    const toast = {
      message: "Something went wrong",
      action: "Dismiss",
      type: constants.FAILED
    };
    return yield put(showToast(toast));
  }
  const state = yield select();
  const { visualDataRefresh } = state;
  const currentData = get(visualDataRefresh, "currentData", []);
  const updateCurrentData = currentData.map(data => {
    if (parseInt(data.id) === parseInt(queue.id)) {
      return {
        ...omit(data, ["callback"]),
        type: JOB_STATUS[STATUS_ENGINE_PREPARING].type,
        statusDescription: JOB_STATUS[STATUS_ENGINE_PREPARING].statusDescription
      };
    }
    return data;
  });
  yield put(getVisualRefreshData(updateCurrentData));
}

export function* removeVisualRefreshDataSaga(action) {
  const { queue } = action.payload;

  const config = yield select(getConfig);
  const results = yield removeVisualDataRefreshApi(config.urlApi, queue.id);

  if (results.error) {
    const toast = {
      message: "Something went wrong",
      action: "Dismiss",
      type: constants.FAILED
    };
    return yield put(showToast(toast));
  }
  const state = yield select();

  const { visualDataRefresh } = state;
  const currentData = get(visualDataRefresh, "currentData", []);
  const updateCurrentData = currentData.filter(
    data => parseInt(data.id) !== parseInt(queue.id)
  );
  yield put(getVisualRefreshData(updateCurrentData));
}

export function* getVisualDataRefreshSaga() {
  const config = yield select(getConfig);
  const state = yield select();
  const { campaignId, advertiserId } = get(state, 'location.payload');

  const results = yield getVisualDataRefreshApi(config.urlApi);
  if (results.error) {
    const toast = {
      message: "Something went wrong",
      action: "Dismiss",
      type: constants.FAILED
    };
    return yield put(showToast(toast));
  }
  const filterResult = results.filter(result => {
    return !!result.title_job && !!result.id
  });
  let allResultsIds = [];
  const updateResult = filterResult.map(data => {
    const campaignName = get(data, "campaign_name");
    const advertiserName = get(data, "advertiser_name", "");
    const description2 = campaignName
      ? `${advertiserName} > ${campaignName}`
      : advertiserName;
    const newId = data.id.toString();
    allResultsIds.push(newId);
    return {
      ...data,
      id: newId,
      description1: getText(data.title_job, 50),
      description2: getText(description2, 60),
      type: JOB_STATUS[data.status_engine].type,
      statusDescription: JOB_STATUS[data.status_engine].statusDescription
    };
  });
  const { visualDataRefresh } = state;
  const currentData = get(visualDataRefresh, "currentData", []);
  let completeQueues = currentData.filter(queue => {
    return (
      queue.status_engine !== JOB_STATUS[STATUS_ENGINE_ERROR].status_engine &&
      !includes(allResultsIds, queue.id)
    );
  });
  let completeQueuesFixedData = [];

  if (completeQueues.length > 0) {
    for (let i = 0; i < completeQueues.length; i++) {
      completeQueuesFixedData.push({
        ...completeQueues[i],
        id: completeQueues[i].id.toString(),
        type: "complete",
        statusDescription: "Complete"
      })
      const campaign_id = get(completeQueues[i], "campaign_id");
      const advertiser_id = get(completeQueues[i], "advertiser_id");

      //Job missing advertiser or campaign
      if (!isNumber(campaign_id) || !advertiser_id) { continue; }
      //Remove selected AdSources
      yield put(updateCampaign({
        campaign_id,
        selectedAdSources: undefined
      }))
      let campaign = {};
      const advertiser = get(state, ["advertiser", "byId", advertiser_id], {});
      const advertiserCampaigns = get(advertiser, "campaigns", []);
      let advertiserCampaignsFilter = advertiserCampaigns.filter(campaign => campaign && (Math.sign(campaign.campaign_id) === 1));
      const chooseCampaign = advertiser.chooseCampaignId || campaignId;
      const isInCurrentAdvertiser = isNumber(advertiser_id) && advertiser_id === get(state, "location.payload.advertiserId");

      /*If job is connect GA, campaign_id = 0,
          remove all chart of job advertiser and update campaign X chart if job advertiser is current advertiser and campaign X is selected,
          in case it don't have any campaign, we just load ad detail if job advertiser is current advertiser, chart will update by itself.
        For other case, we simply remove campaign chart and update one that currently selected in current advertiser,
          those campaign is not currently selected will update when reselect or change advertiser.
      */

      if (campaign_id === 0) {
        if (advertiserCampaignsFilter.length) {
          for (let i = 0; i < advertiserCampaignsFilter.length; i++) {
            const campaignId = advertiserCampaignsFilter[i] && advertiserCampaignsFilter[i].campaign_id;
            if (isInCurrentAdvertiser && campaignId === chooseCampaign) {
              campaign = get(state, ["campaign", "byId", campaignId]);
            }
            yield put(removeChartData(campaignId));
          }
        } else {
          if (isInCurrentAdvertiser) {
            yield put(loadAdvertiserDetailSaga(advertiser_id));
          }
          continue;
        }
      } else {
        if (campaignId !== campaign_id) {
          yield put(removeChartData(campaign_id));
        }
      }
      if (isInCurrentAdvertiser && campaign_id === chooseCampaign) {
        campaign = get(state, ["campaign", "byId", campaign_id]);
      }

      const dateRange = "";
      if (!isEmpty(campaign) && isInCurrentAdvertiser) {
        /*
          At Dashboard Tab, if we change campaign/advertiser... and next campaign chart data is empty
          It will call chart again by itself
          So if it not choose Campaign, we only remove chart (using isOverride bool in loadChartDataCampaignSaga)
          and let it call chart itself
        */
        const isCallChartItSelf = campaign_id === 0 || campaign_id === chooseCampaign;
        let detail = {};
        if (isCallChartItSelf) {
          const campaignData = yield put(loadCampaigns([chooseCampaign], true));
          if (campaignData && !campaignData.error) {
            detail = campaignData;
          }
        }
        const formattedCampaign = omit(campaign, [
          'loadStatus',
          'totalErrorsCount',
          'lastRunDate'
        ]);
        campaign = {
          ...formattedCampaign,
          selectedAdSources: undefined,
          ...detail,
        }
        yield put(loadChartDataCampaignSaga(advertiser, campaign, dateRange, !isCallChartItSelf));
      }
    }
    const newCurrentData = [...completeQueuesFixedData, ...updateResult];
    const sortNewCurrentData = reverse(sortBy(newCurrentData, "id"));
    yield put(getVisualRefreshData(sortNewCurrentData));
    yield delay(14800);
    yield put(getVisualRefreshData(updateResult));
  }
  yield put(getVisualRefreshData(updateResult));
}

export default function* auth() {
  yield all([
    takeEvery(RE_PROCESS_SAGA, reProcessSaga),
    takeEvery(REMOVE_VISUAL_REFRESH_DATA_SAGA, removeVisualRefreshDataSaga),
    takeEvery(GET_VISUAL_DATA_REFRESH_SAGA, getVisualDataRefreshSaga)
  ]);
}
